/* eslint-disable quotes */
export const landingTranslations = {
  'en-GB': {
    landing: {
      docTitle: 'Colozoo - Claim Your Free Gift',
      pageTitle: '🎨 Thanks for Choosing Colozoo!',
      feedbackIntro: "Your feedback means the world to us. It helps us grow, improve, and keep making colourful, creative tools you'll love.",
      freeProductOffer: "As a thank you we'd love to give you another Colozoo product (up to £25 value) for free!",
      howToClaimTitle: '🎁 How to Claim Your Free Gift:',
      howToClaimStep1: 'Leave a review on Amazon for the Colozoo product you bought.',
      howToClaimStep1Detail: 'Your review must include text and at least one photo or video of your art or the product in use.',
      howToClaimStep2: 'Wait 1–2 days for Amazon to publish your review (they can be slow sometimes).',
      howToClaimStep3: 'Fill out the form below with:',
      howToClaimListItemReviewLink: 'A link to your review',
      howToClaimListItemOrderNumber: 'Your Amazon order number',
      howToClaimListItemEmail: 'Your email address',
      howToClaimListItemShipping: 'Your shipping address (if different from your order)',
      howToClaimListItemProductChoice: 'The Colozoo product(s) you’d like – up to £25 from',
      amazonStoreLinkText: 'our Amazon store (click here to browse)',
      importantNotesTitle: '📝 A Few Important Notes:',
      importantNotesItem1: '📸 We love seeing your creations — the more visual, the better!',
      importantNotesItem2: '🌍 This offer is valid once per customer.',
      importantNotesItem3: '🛒 Your Amazon account must have at least £50 in purchases within the last 12 months to be eligible to leave a review.',
      importantNotesItem4: '🌎 This promotion is open to customers in: France, Spain, Germany, Denmark, Sweden, Finland, Belgium, Portugal, Italy, Ireland, Luxembourg, Netherlands, Austria, Bulgaria, Croatia, Cyprus, Czech Republic, Estonia, Greece, Hungary, Latvia, Lithuania, Malta, Poland, Romania, Slovakia, Slovenia, USA.',
      importantNotesItem5: '❌ Had an issue with your order? Please reach out to us directly at support@colozoo.de instead of leaving a negative review — we’ll do everything we can to help.',
      skipToFormButtonText: 'Ready to claim your gift? Skip ahead to the form!',
      goToClaimFormButton: 'Go to Claim Form',
      faqTitle: '❓ Frequently Asked Questions',
      examplesTitle: 'Here are some examples of what a great review looks like:',
      viewExampleReviewButton: 'View Example Review on Amazon',
      formTitle: '💌 Ready? Fill Out the Form Below to Get Your Free Product!',
      footerContact: 'Have any other questions? Don’t hesitate to reach out on support@colozoo.de',
      footerColozooWebsite: 'Colozoo Website',
      footerLegalNotice: 'Legal Notice',
      footerPrivacyPolicy: 'Privacy Policy',
      links: {
        storeLink: "https://www.amazon.co.uk/stores/Colozoo/page/D00BCC46-3519-4856-B012-FD748CFEE7D6",
        review1: "https://www.amazon.co.uk/gp/customer-reviews/R8K1PV9YWQEOJ/",
        review2: "https://www.amazon.co.uk/gp/customer-reviews/R1DT9BSJH8N85K/",
        review3: "https://www.amazon.co.uk/gp/customer-reviews/R21OKMVV9PYXO9/"
      },
      faq: {
        item0: {
          header: 'How do I leave an Amazon review?',
          contentLi1: 'Go to the product page on Amazon for the Colozoo item you purchased.',
          contentLi2: 'Scroll down to the "Customer reviews" section.',
          contentLi3: 'Click the "Write a customer review" button.',
          contentLi4: 'Rate the product using the stars.',
          contentLi5: 'Write your review text in the box provided.',
          contentLi6Strong: 'Important:',
          contentLi6Text: 'Click "Add a photo or video" to upload your image or video. Reviews must include a visual to qualify for the free gift.',
          contentLi7: 'Click "Submit".',
          contentP1Text1: 'Remember, it might take 1-2 days for Amazon to publish your review. You can find your submitted reviews on',
          contentP1LinkText: 'your Amazon Profile page',
          contentP1Text2: '.',
        },
        item1: {
          header: 'Can I choose multiple small products that add up to £25?',
          content: 'You can choose one product up to £25. However, for multiple products, due to high shipping costs, we can only ship a combined value of up to £15.',
        },
        item2: {
          header: 'How long until I get my freebie?',
          content: 'We usually ship it within a week after checking your review. We will send you a notification once it’s on its way, and if you won’t get it within 10 days, please write us back to support@colozoo.de.',
        },
        item3: {
          header: 'I don’t want to share my artwork in the review?',
          content: 'No problem! Just add a picture of the product you received and write a few words about it.',
        },
        item4: {
          header: 'I can’t find the link to my Amazon review. What should I do?',
          contentP1Text1: 'Sometimes reviews take up to 72 hours to appear. You can read all the reviews you\'ve written by visiting',
          contentP1LinkText: 'your Amazon Profile page',
          contentP1Text2: 'and copy the URL from your browser.',
        },
        item5: {
          header: 'What if the product I want is out of stock?',
          content: 'We are sorry, you can only choose products that are currently in stock and available on the Amazon website of your country.',
        },
        item6: {
          header: 'Can I choose a product over £25 and pay the difference?',
          content: 'Sorry, the free gift must be £25 or less – no top-ups or partial payments are possible.',
        },
        item7: {
          header: 'How will I know you received my form?',
          content: 'You’ll get a confirmation message right after submitting (as implemented in the form component). If you don’t hear from us within 5 days, feel free to reach out to support@colozoo.de!',
        },
        item8: {
          header: 'Do I need to keep the packaging or receipt?',
          content: 'Nope! Just your order number and review link are enough.',
        },
        item9: {
          header: 'Can I leave the review in my native language?',
          content: 'Yes! Any language is fine, as long as it\'s a genuine review with text and an image or video.',
        },
        item10: {
          header: 'I ordered another product, can I leave another review and get another free product?',
          content: 'We will be very happy if you will leave us another loving review, but unfortunately we can only send the free products once per customer.',
        }
      },
      form: {
        reviewLinkLabel: 'Link to Your Amazon Review *',
        reviewLinkPlaceholder: 'https://www.amazon...',
        reviewLinkRequiredMsg: 'Please paste the link to your review!',
        reviewLinkValidUrlMsg: 'Please enter a valid URL!',
        orderNumberLabel: 'Amazon Order Number *',
        orderNumberPlaceholder: 'e.g., 123-4567890-1234567',
        orderNumberRequiredMsg: 'Please enter your Amazon order number!',
        emailLabel: 'Your Email Address *',
        emailPlaceholder: 'your.email@example.com',
        emailRequiredMsg: 'Please enter your email address!',
        emailValidMsg: 'Please enter a valid email address!',
        shippingAddressLabel: 'Shipping Address (if different from your order)',
        streetPlaceholder: 'Street and House Number',
        streetRequiredMsg: 'Please enter your street address!',
        cityPlaceholder: 'City',
        cityRequiredMsg: 'Please enter your city!',
        postalCodePlaceholder: 'Postal Code',
        postalCodeRequiredMsg: 'Please enter your postal code!',
        countryPlaceholder: 'Country',
        countryRequiredMsg: 'Please enter your country!',        
        namePlaceholder: 'Full Name',
        desiredProductLabel: "Colozoo Product(s) You'd Like (up to £25 total value) *",
        desiredProductLinkText: 'Browse our store here',
        desiredProductPlaceholder: "Enter the name(s) or ASIN(s) of the product(s) you'd like",
        desiredProductRequiredMsg: 'Please tell us which product you would like!',
        consentCheckboxLabel: 'I understand this offer is valid once per customer and my review includes text and a photo/video. I also consent to the terms described in the privacy policy. *',
        consentRequiredMsg: 'You must agree to the terms',
        marketingConsentCheckboxLabel: 'Send me emails about new Colozoo products and other promotions, we promise not to spam you',
        submitButtonText: 'Submit Claim',
        submittingButtonText: 'Submitting...',
        submissionSuccessTitle: 'Form Submitted!',
        submissionSuccessMessage: 'Thank you! You’ll get a confirmation message right after submitting. If you don’t hear from us within 5 days, feel free to reach out to support@colozoo.de!',
        submissionErrorTitle: 'Submission Error',
        submissionErrorMessage: 'There was a problem submitting your claim. Please try again or contact support.',
        submissionFailedTitle: 'Submission Failed',
        submissionFailedMessage: 'Please check the form fields for errors.',
      }
    }
  },
  'en-US': {
    landing: {
      docTitle: 'Colozoo - Claim Your Free Gift',
      pageTitle: '🎨 Thanks for Choosing Colozoo!',
      feedbackIntro: "Your feedback means the world to us. It helps us grow, improve, and keep making colorful, creative tools you'll love.",
      freeProductOffer: "As a thank you we'd love to give you another Colozoo product (up to $25 value) for free!",
      howToClaimTitle: '🎁 How to Claim Your Free Gift:',
      howToClaimStep1: 'Leave a review on Amazon for the Colozoo product you bought.',
      howToClaimStep1Detail: 'Your review must include text and at least one photo or video of your art or the product in use.',
      howToClaimStep2: 'Wait 1–2 days for Amazon to publish your review (they can be slow sometimes).',
      howToClaimStep3: 'Fill out the form below with:',
      howToClaimListItemReviewLink: 'A link to your review',
      howToClaimListItemOrderNumber: 'Your Amazon order number',
      howToClaimListItemEmail: 'Your email address',
      howToClaimListItemShipping: 'Your shipping address (if different from your order)',
      howToClaimListItemProductChoice: 'The Colozoo product(s) you’d like – up to $25 from',
      amazonStoreLinkText: 'our Amazon store (click here to browse)',
      importantNotesTitle: '📝 A Few Important Notes:',
      importantNotesItem1: '📸 We love seeing your creations — the more visual, the better!',
      importantNotesItem2: '🌍 This offer is valid once per customer.',
      importantNotesItem3: '🛒 Your Amazon account must have at least $50 in purchases within the last 12 months to be eligible to leave a review.',
      importantNotesItem4: '🌎 This promotion is open to customers in: France, Spain, Germany, Denmark, Sweden, Finland, Belgium, Portugal, Italy, Ireland, Luxembourg, Netherlands, Austria, Bulgaria, Croatia, Cyprus, Czech Republic, Estonia, Greece, Hungary, Latvia, Lithuania, Malta, Poland, Romania, Slovakia, Slovenia, USA.',
      importantNotesItem5: '❌ Had an issue with your order? Please reach out to us directly at support@colozoo.de instead of leaving a negative review — we’ll do everything we can to help.',
      skipToFormButtonText: 'Ready to claim your gift? Skip ahead to the form!',
      goToClaimFormButton: 'Go to Claim Form',
      faqTitle: '❓ Frequently Asked Questions',
      examplesTitle: 'Here are some examples of what a great review looks like:',
      viewExampleReviewButton: 'View Example Review on Amazon',
      formTitle: '💌 Ready? Fill Out the Form Below to Get Your Free Product!',
      footerContact: 'Have any other questions? Don’t hesitate to reach out on support@colozoo.de',
      footerColozooWebsite: 'Colozoo Website',
      footerLegalNotice: 'Legal Notice',
      footerPrivacyPolicy: 'Privacy Policy',
      links: {
        storeLink: "https://www.amazon.com/stores/Colozoo/page/C207523A-55EB-4191-B263-65E44BA822FD",
        review1: "https://www.amazon.co.uk/gp/customer-reviews/R8K1PV9YWQEOJ/",
        review2: "https://www.amazon.co.uk/gp/customer-reviews/R1DT9BSJH8N85K/",
        review3: "https://www.amazon.co.uk/gp/customer-reviews/R21OKMVV9PYXO9/"
      },
      faq: {
        item0: {
          header: 'How do I leave an Amazon review?',
          contentLi1: 'Go to the product page on Amazon for the Colozoo item you purchased.',
          contentLi2: 'Scroll down to the "Customer reviews" section.',
          contentLi3: 'Click the "Write a customer review" button.',
          contentLi4: 'Rate the product using the stars.',
          contentLi5: 'Write your review text in the box provided.',
          contentLi6Strong: 'Important:',
          contentLi6Text: 'Click "Add a photo or video" to upload your image or video. Reviews must include a visual to qualify for the free gift.',
          contentLi7: 'Click "Submit".',
          contentP1Text1: 'Remember, it might take 1-2 days for Amazon to publish your review. You can find your submitted reviews on',
          contentP1LinkText: 'your Amazon Profile page',
          contentP1Text2: '.',
        },
        item1: {
          header: 'Can I choose multiple small products that add up to $25?',
          content: 'You can choose one product up to $25. However, for multiple products, due to high shipping costs, we can only ship a combined value of up to $15.',
        },
        item2: {
          header: 'How long until I get my freebie?',
          content: 'We usually ship it within a week after checking your review. We will send you a notification once it’s on its way, and if you won’t get it within 10 days, please write us back to support@colozoo.de.',
        },
        item3: {
          header: 'I don’t want to share my artwork in the review?',
          content: 'No problem! Just add a picture of the product you received and write a few words about it.',
        },
        item4: {
          header: 'I can’t find the link to my Amazon review. What should I do?',
          contentP1Text1: 'Sometimes reviews take up to 72 hours to appear. You can read all the reviews you\'ve written by visiting',
          contentP1LinkText: 'your Amazon Profile page',
          contentP1Text2: 'and copy the URL from your browser.',
        },
        item5: {
          header: 'What if the product I want is out of stock?',
          content: 'We are sorry, you can only choose products that are currently in stock and available on the Amazon website of your country.',
        },
        item6: {
          header: 'Can I choose a product over $25 and pay the difference?',
          content: 'Sorry, the free gift must be $25 or less – no top-ups or partial payments are possible.',
        },
        item7: {
          header: 'How will I know you received my form?',
          content: 'You’ll get a confirmation message right after submitting (as implemented in the form component). If you don’t hear from us within 5 days, feel free to reach out to support@colozoo.de!',
        },
        item8: {
          header: 'Do I need to keep the packaging or receipt?',
          content: 'Nope! Just your order number and review link are enough.',
        },
        item9: {
          header: 'Can I leave the review in my native language?',
          content: 'Yes! Any language is fine, as long as it\'s a genuine review with text and an image or video.',
        },
        item10: {
          header: 'I ordered another product, can I leave another review and get another free product?',
          content: 'We will be very happy if you will leave us another loving review, but unfortunately we can only send the free products once per customer.',
        }
      },
      form: {
        reviewLinkLabel: 'Link to Your Amazon Review *',
        reviewLinkPlaceholder: 'https://www.amazon...',
        reviewLinkRequiredMsg: 'Please paste the link to your review!',
        reviewLinkValidUrlMsg: 'Please enter a valid URL!',
        orderNumberLabel: 'Amazon Order Number *',
        orderNumberPlaceholder: 'e.g., 123-4567890-1234567',
        orderNumberRequiredMsg: 'Please enter your Amazon order number!',
        emailLabel: 'Your Email Address *',
        emailPlaceholder: 'your.email@example.com',
        emailRequiredMsg: 'Please enter your email address!',
        emailValidMsg: 'Please enter a valid email address!',
        shippingAddressLabel: 'Shipping Address (if different from your order)',
        streetPlaceholder: 'Street and House Number',
        streetRequiredMsg: 'Please enter your street address!',
        cityPlaceholder: 'City',
        cityRequiredMsg: 'Please enter your city!',
        postalCodePlaceholder: 'Postal Code',
        postalCodeRequiredMsg: 'Please enter your postal code!',
        countryPlaceholder: 'Country',
        countryRequiredMsg: 'Please enter your country!',        
        namePlaceholder: 'Full Name',
        desiredProductLabel: "Colozoo Product(s) You'd Like (up to $25 total value) *",
        desiredProductLinkText: 'Browse our store here',
        desiredProductPlaceholder: "Enter the name(s) or ASIN(s) of the product(s) you'd like",
        desiredProductRequiredMsg: 'Please tell us which product you would like!',
        consentCheckboxLabel: 'I understand this offer is valid once per customer and my review includes text and a photo/video. I also consent to the terms described in the privacy policy. *',
        consentRequiredMsg: 'You must agree to the terms',
        marketingConsentCheckboxLabel: 'Send me emails about new Colozoo products and other promotions, we promise not to spam you',
        submitButtonText: 'Submit Claim',
        submittingButtonText: 'Submitting...',
        submissionSuccessTitle: 'Form Submitted!',
        submissionSuccessMessage: 'Thank you! You’ll get a confirmation message right after submitting. If you don’t hear from us within 5 days, feel free to reach out to support@colozoo.de!',
        submissionErrorTitle: 'Submission Error',
        submissionErrorMessage: 'There was a problem submitting your claim. Please try again or contact support.',
        submissionFailedTitle: 'Submission Failed',
        submissionFailedMessage: 'Please check the form fields for errors.',
      }
    }
  },
  de: {
    landing: {
      docTitle: 'Colozoo - Hol Dir Dein kostenloses Geschenk',
      pageTitle: '🎨 Danke, dass Du Dich für Colozoo entschieden hast!',
      feedbackIntro: 'Dein Feedback bedeutet uns die Welt. Es hilft uns zu wachsen, uns zu verbessern und weiterhin farbenfrohe, kreative Werkzeuge zu entwickeln, die Du lieben wirst.',
      freeProductOffer: 'Als Dankeschön möchten wir Dir gerne ein weiteres Colozoo-Produkt (im Wert von bis zu 25 €) kostenlos schenken!',
      howToClaimTitle: '🎁 So bekommst Du Dein kostenloses Geschenk:',
      howToClaimStep1: 'Hinterlasse eine Bewertung auf Amazon für das Colozoo-Produkt, das Du gekauft hast.',
      howToClaimStep1Detail: 'Deine Bewertung muss Text und mindestens ein Foto oder Video Deiner Kunstwerke oder des Produkts in Verwendung enthalten.',
      howToClaimStep2: 'Warte 1–2 Tage, bis Amazon Deine Bewertung veröffentlicht (das kann manchmal etwas dauern).',
      howToClaimStep3: 'Fülle das folgende Formular aus mit:',
      howToClaimListItemReviewLink: 'Einem Link zu Deiner Bewertung',
      howToClaimListItemOrderNumber: 'Deiner Amazon-Bestellnummer',
      howToClaimListItemEmail: 'Deiner E-Mail-Adresse',
      howToClaimListItemShipping: 'Deiner Lieferadresse (falls sie von Deiner Bestelladresse abweicht)',
      howToClaimListItemProductChoice: 'Dem/den gewünschten Colozoo-Produkt(en) – bis zu 25 € aus',
      amazonStoreLinkText: 'unserem Amazon-Shop (jetzt durchstöbern)',
      importantNotesTitle: '📝 Ein paar wichtige Hinweise:',
      importantNotesItem1: '📸 Wir lieben es, Deine Kreationen zu sehen – je anschaulicher, desto besser!',
      importantNotesItem2: '🌍 Dieses Angebot gilt einmal pro Kunde.',
      importantNotesItem3: '🛒 Dein Amazon-Konto muss in den letzten 12 Monaten Einkäufe im Wert von mindestens 50 € getätigt haben, um berechtigt zu sein, eine Bewertung abzugeben.',
      importantNotesItem4: '🌎 Diese Aktion steht Kunden in folgenden Ländern offen: Frankreich, Spanien, Deutschland, Dänemark, Schweden, Finnland, Belgien, Portugal, Italien, Irland, Luxemburg, Niederlande, Österreich, Bulgarien, Kroatien, Zypern, Tschechische Republik, Estland, Griechenland, Ungarn, Lettland, Litauen, Malta, Polen, Rumänien, Slowakei, Slowenien, USA.',
      importantNotesItem5: '❌ Gab es ein Problem mit Deiner Bestellung? Bitte kontaktiere uns direkt unter support@colozoo.de, anstatt eine negative Bewertung zu hinterlassen – wir werden alles tun, um Dir zu helfen.',
      skipToFormButtonText: 'Bereit, Dein Geschenk zu beantragen? Spring direkt zum Formular!',
      goToClaimFormButton: 'Zum Antragsformular',
      faqTitle: '❓ Häufig gestellte Fragen',
      examplesTitle: 'Hier sind ein paar Beispiele für großartige Bewertungen:',
      viewExampleReviewButton: 'Beispielbewertung auf Amazon ansehen',
      formTitle: '💌 Bereit? Fülle das Formular unten aus, um Dein kostenloses Produkt zu erhalten!',
      footerContact: 'Hast Du noch andere Fragen? Zögere nicht, uns unter support@colozoo.de zu kontaktieren',
      footerColozooWebsite: 'Colozoo Webseite',
      footerLegalNotice: 'Impressum',
      footerPrivacyPolicy: 'Datenschutzerklärung',
      links: {
        storeLink: "https://www.amazon.de/stores/Colozoo/page/088F6D23-55D5-4281-ACB4-0E0BFBDD99A3",
        review1: "https://www.amazon.de/gp/customer-reviews/R8K1PV9YWQEOJ/",
        review2: "https://www.amazon.de/gp/customer-reviews/R1DT9BSJH8N85K/",
        review3: "https://www.amazon.de/gp/customer-reviews/R21OKMVV9PYXO9/"
      },
      faq: {
        item0: {
          header: 'Wie hinterlasse ich eine Amazon-Bewertung?',
          contentLi1: 'Gehe zur Produktseite auf Amazon für den Colozoo-Artikel, den Du gekauft hast.',
          contentLi2: 'Scrolle nach unten zum Abschnitt "Kundenbewertungen".',
          contentLi3: 'Klicke auf die Schaltfläche "Kundenbewertung schreiben".',
          contentLi4: 'Bewerte das Produkt mit den Sternen.',
          contentLi5: 'Schreibe Deinen Bewertungstext in das dafür vorgesehene Feld.',
          contentLi6Strong: 'Wichtig:',
          contentLi6Text: 'Klicke auf "Foto oder Video hinzufügen", um Dein Bild oder Video hochzuladen. Bewertungen müssen ein Bild enthalten, um für das kostenlose Geschenk berechtigt zu sein.',
          contentLi7: 'Klicke auf "Senden".',
          contentP1Text1: 'Denke daran: Es kann 1-2 Tage dauern, bis Amazon Deine Bewertung veröffentlicht. Du findest Deine eingereichten Bewertungen auf',
          contentP1LinkText: 'Deiner Amazon-Profilseite',
          contentP1Text2: '.',
        },
        item1: {
          header: 'Kann ich mehrere kleine Produkte auswählen, die zusammen 25 € ergeben?',
          content: 'Du kannst ein Produkt bis zu 25 € auswählen. Für mehrere Produkte können wir jedoch aufgrund der hohen Versandkosten nur einen Gesamtwert von bis zu 15 € versenden.',
        },
        item2: {
          header: 'Wie lange dauert es, bis ich mein Gratis-Geschenk erhalte?',
          content: 'Normalerweise versenden wir es innerhalb einer Woche, nachdem wir Deine Bewertung überprüft haben. Wir senden Dir eine Benachrichtigung, sobald es unterwegs ist. Falls Du es nicht innerhalb von 10 Tagen erhältst, schreibe uns bitte an support@colozoo.de.',
        },
        item3: {
          header: 'Ich möchte meine Kunstwerke nicht in der Bewertung zeigen?',
          content: 'Kein Problem! Füge einfach ein Foto des erhaltenen Produkts hinzu und schreibe ein paar Worte darüber.',
        },
        item4: {
          header: 'Ich finde den Link zu meiner Amazon-Bewertung nicht. Was soll ich tun?',
          contentP1Text1: 'Manchmal dauert es bis zu 72 Stunden, bis Bewertungen erscheinen. Du kannst alle Bewertungen, die Du geschrieben hast, einsehen, indem Du',
          contentP1LinkText: 'Deine Amazon-Profilseite',
          contentP1Text2: 'besuchst und die URL aus Deinem Browser kopierst.',
        },
        item5: {
          header: 'Was ist, wenn das gewünschte Produkt nicht auf Lager ist?',
          content: 'Es tut uns leid, Du kannst nur Produkte auswählen, die derzeit vorrätig und auf der Amazon-Website Deines Landes verfügbar sind.',
        },
        item6: {
          header: 'Kann ich ein Produkt über 25 € auswählen und die Differenz bezahlen?',
          content: 'Entschuldigung, das Gratis-Geschenk muss 25 € oder weniger kosten – Zuzahlungen oder Teilzahlungen sind nicht möglich.',
        },
        item7: {
          header: 'Woher weiß ich, dass Ihr mein Formular erhalten habt?',
          content: 'Du erhältst direkt nach dem Absenden eine Bestätigungsnachricht (wie in der Formularkomponente implementiert). Falls Du innerhalb von 5 Tagen nichts von uns hörst, melde Dich gerne bei support@colozoo.de!',
        },
        item8: {
          header: 'Muss ich die Verpackung oder den Kassenzettel aufbewahren?',
          content: 'Nein! Nur Deine Bestellnummer und der Bewertungslink reichen aus.',
        },
        item9: {
          header: 'Kann ich die Bewertung in meiner Muttersprache schreiben?',
          content: 'Ja! Jede Sprache ist in Ordnung, solange es sich um eine echte Bewertung mit Text und einem Bild oder Video handelt.',
        },
        item10: {
          header: 'Ich habe noch ein anderes Produkt bestellt. Kann ich eine weitere Bewertung schreiben und noch ein kostenloses Produkt bekommen?',
          content: 'Wir würden uns riesig über eine weitere liebevolle Bewertung freuen, aber leider können wir die kostenlosen Produkte nur einmal pro Kunde versenden.',
        }
      },
      form: {
        reviewLinkLabel: 'Link zu Deiner Amazon-Bewertung *',
        reviewLinkPlaceholder: 'https://www.amazon...',
        reviewLinkRequiredMsg: 'Bitte füge den Link zu Deiner Bewertung ein!',
        reviewLinkValidUrlMsg: 'Bitte gib eine gültige URL ein!',
        orderNumberLabel: 'Amazon-Bestellnummer *',
        orderNumberPlaceholder: 'z.B. 123-4567890-1234567',
        orderNumberRequiredMsg: 'Bitte gib Deine Amazon-Bestellnummer ein!',
        emailLabel: 'Deine E-Mail-Adresse *',
        emailPlaceholder: 'deine.email@beispiel.com',
        emailRequiredMsg: 'Bitte gib Deine E-Mail-Adresse ein!',
        emailValidMsg: 'Bitte gib eine gültige E-Mail-Adresse ein!',
        shippingAddressLabel: 'Lieferadresse (falls sie von Deiner Bestellung abweicht)',
        streetPlaceholder: 'Straße und Hausnummer',
        streetRequiredMsg: 'Bitte gib Deine Straße und Hausnummer ein!',
        cityPlaceholder: 'Stadt',
        cityRequiredMsg: 'Bitte gib Deine Stadt ein!',
        postalCodePlaceholder: 'Postleitzahl',
        postalCodeRequiredMsg: 'Bitte gib Deine Postleitzahl ein!',
        countryPlaceholder: 'Land',
        countryRequiredMsg: 'Bitte gib Dein Land ein!',        
        namePlaceholder: 'Vollständiger Name',
        desiredProductLabel: 'Gewünschte(s) Colozoo-Produkt(e) (Gesamtwert bis zu 25 €) *',
        desiredProductLinkText: 'Hier geht\'s zu unserem Shop',
        desiredProductPlaceholder: 'Gib den/die Namen oder ASIN(s) des/der gewünschten Produkts/Produkte ein',
        desiredProductRequiredMsg: 'Bitte teile uns mit, welches Produkt Du möchtest!',
        consentCheckboxLabel: 'Ich verstehe, dass dieses Angebot einmal pro Kunde gilt und meine Bewertung Text sowie ein Foto/Video enthält. Ich stimme außerdem den Bedingungen in der Datenschutzerklärung zu. *',
        consentRequiredMsg: 'Du musst den Bedingungen zustimmen',
        marketingConsentCheckboxLabel: 'Sendet mir E-Mails über neue Colozoo-Produkte und andere Aktionen – wir versprechen, Euch nicht zu spammen',
        submitButtonText: 'Antrag einreichen',
        submittingButtonText: 'Wird eingereicht...',
        submissionSuccessTitle: 'Formular gesendet!',
        submissionSuccessMessage: 'Vielen Dank! Du erhältst direkt nach dem Absenden eine Bestätigungsnachricht. Falls Du innerhalb von 5 Tagen nichts von uns hörst, melde Dich gerne bei support@colozoo.de!',
        submissionErrorTitle: 'Fehler beim Senden',
        submissionErrorMessage: 'Beim Einreichen Deines Antrags ist ein Problem aufgetreten. Bitte versuche es erneut oder kontaktiere den Support.',
        submissionFailedTitle: 'Senden fehlgeschlagen',
        submissionFailedMessage: 'Bitte überprüfe die Formularfelder auf Fehler.',
      }
    }
  },
  fr: {
    landing: {
      docTitle: 'Colozoo - Réclamez Votre Cadeau Gratuit',
      pageTitle: '🎨 Merci d\'avoir choisi Colozoo !',
      feedbackIntro: "Vos commentaires comptent énormément pour nous. Ils nous aident à grandir, à nous améliorer et à continuer de créer des outils colorés et créatifs que vous allez adorer.",
      freeProductOffer: "En guise de remerciement, nous aimerions vous offrir gratuitement un autre produit Colozoo (d'une valeur maximale de 25 €) !",
      howToClaimTitle: '🎁 Comment réclamer votre cadeau gratuit :',
      howToClaimStep1: 'Laissez un avis sur Amazon pour le produit Colozoo que vous avez acheté.',
      howToClaimStep1Detail: 'Votre avis doit inclure du texte et au moins une photo ou une vidéo de votre œuvre d\'art ou du produit en cours d\'utilisation.',
      howToClaimStep2: 'Attendez 1 à 2 jours qu\'Amazon publie votre avis (ils peuvent parfois être lents).',
      howToClaimStep3: 'Remplissez le formulaire ci-dessous avec :',
      howToClaimListItemReviewLink: 'Un lien vers votre avis',
      howToClaimListItemOrderNumber: 'Votre numéro de commande Amazon',
      howToClaimListItemEmail: 'Votre adresse e-mail',
      howToClaimListItemShipping: 'Votre adresse de livraison (si différente de celle de votre commande)',
      howToClaimListItemProductChoice: 'Le(s) produit(s) Colozoo que vous souhaitez – jusqu\'à 25 € depuis',
      amazonStoreLinkText: 'notre boutique Amazon (cliquez ici pour parcourir)',
      importantNotesTitle: '📝 Quelques remarques importantes :',
      importantNotesItem1: '📸 Nous adorons voir vos créations — plus c\'est visuel, mieux c\'est !',
      importantNotesItem2: '🌍 Cette offre est valable une fois par client.',
      importantNotesItem3: '🛒 Votre compte Amazon doit avoir effectué au moins 50 € d\'achats au cours des 12 derniers mois pour pouvoir laisser un avis.',
      importantNotesItem4: '🌎 Cette promotion est ouverte aux clients en : France, Espagne, Allemagne, Danemark, Suède, Finlande, Belgique, Portugal, Italie, Irlande, Luxembourg, Pays-Bas, Autriche, Bulgarie, Croatie, Chypre, République tchèque, Estonie, Grèce, Hongrie, Lettonie, Lituanie, Malte, Pologne, Roumanie, Slovaquie, Slovénie, États-Unis.',
      importantNotesItem5: '❌ Vous avez eu un problème avec votre commande ? Veuillez nous contacter directement à support@colozoo.de au lieu de laisser un avis négatif — nous ferons tout notre possible pour vous aider.',
      skipToFormButtonText: 'Prêt à réclamer votre cadeau ? Passez directement au formulaire !',
      goToClaimFormButton: 'Aller au formulaire de réclamation',
      faqTitle: '❓ Questions fréquemment posées',
      examplesTitle: 'Voici quelques exemples de ce à quoi ressemble un excellent avis :',
      viewExampleReviewButton: 'Voir l\'exemple d\'avis sur Amazon',
      formTitle: '💌 Prêt(e) ? Remplissez le formulaire ci-dessous pour obtenir votre produit gratuit !',
      footerContact: 'Vous avez d\'autres questions ? N\'hésitez pas à nous contacter à support@colozoo.de',
      footerColozooWebsite: 'Site Web Colozoo',
      footerLegalNotice: 'Mentions Légales',
      footerPrivacyPolicy: 'Politique de Confidentialité',
      links: {
        storeLink: "https://www.amazon.fr/stores/Colozoo/page/315C207E-1141-4BBF-83D1-F857DA73F838",
        review1: "https://www.amazon.fr/gp/customer-reviews/R8K1PV9YWQEOJ/",
        review2: "https://www.amazon.fr/gp/customer-reviews/R1DT9BSJH8N85K/",
        review3: "https://www.amazon.fr/gp/customer-reviews/R21OKMVV9PYXO9/"
      },
      faq: {
        item0: {
          header: 'Comment laisser un avis sur Amazon ?',
          contentLi1: 'Rendez-vous sur la page produit Amazon de l\'article Colozoo que vous avez acheté.',
          contentLi2: 'Faites défiler jusqu\'à la section "Avis clients".',
          contentLi3: 'Cliquez sur le bouton "Écrire un avis client".',
          contentLi4: 'Évaluez le produit en utilisant les étoiles.',
          contentLi5: 'Rédigez le texte de votre avis dans la case prévue.',
          contentLi6Strong: 'Important :',
          contentLi6Text: 'Cliquez sur "Ajouter une photo ou une vidéo" pour télécharger votre image ou vidéo. Les avis doivent inclure un élément visuel pour être éligibles au cadeau gratuit.',
          contentLi7: 'Cliquez sur "Soumettre".',
          contentP1Text1: 'N\'oubliez pas, la publication de votre avis par Amazon peut prendre 1 à 2 jours. Vous pouvez retrouver vos avis soumis sur',
          contentP1LinkText: 'votre page de profil Amazon',
          contentP1Text2: '.',
        },
        item1: {
          header: 'Puis-je choisir plusieurs petits produits dont la somme atteint 25 € ?',
          content: 'Vous pouvez choisir un produit jusqu\'à 25 €. Cependant, pour plusieurs produits, en raison des frais de port élevés, nous ne pouvons expédier qu\'un montant total pouvant atteindre 15 €.',
        },
        item2: {
          header: 'Combien de temps avant de recevoir mon cadeau ?',
          content: 'Nous l\'expédions généralement dans la semaine suivant la vérification de votre avis. Nous vous enverrons une notification dès qu\'il sera en route, et si vous ne le recevez pas dans les 10 jours, veuillez nous écrire à support@colozoo.de.',
        },
        item3: {
          header: 'Je ne veux pas partager mon œuvre d\'art dans l\'avis ?',
          content: 'Aucun problème ! Ajoutez simplement une photo du produit que vous avez reçu et écrivez quelques mots à son sujet.',
        },
        item4: {
          header: 'Je ne trouve pas le lien vers mon avis Amazon. Que dois-je faire ?',
          contentP1Text1: 'Parfois, l\'apparition des avis peut prendre jusqu\'à 72 heures. Vous pouvez lire tous les avis que vous avez écrits en visitant',
          contentP1LinkText: 'votre page de profil Amazon',
          contentP1Text2: 'et copier l\'URL depuis votre navigateur.',
        },
        item5: {
          header: 'Que faire si le produit que je veux est en rupture de stock ?',
          content: 'Nous sommes désolés, vous ne pouvez choisir que des produits actuellement en stock et disponibles sur le site Amazon de votre pays.',
        },
        item6: {
          header: 'Puis-je choisir un produit de plus de 25 € et payer la différence ?',
          content: 'Désolé, le cadeau gratuit doit être de 25 € ou moins – aucun complément ou paiement partiel n\'est possible.',
        },
        item7: {
          header: 'Comment saurai-je que vous avez reçu mon formulaire ?',
          content: 'Vous recevrez un message de confirmation juste après la soumission (comme implémenté dans le composant formulaire). Si vous n\'avez pas de nouvelles de notre part dans les 5 jours, n\'hésitez pas à contacter support@colozoo.de !',
        },
        item8: {
          header: 'Dois-je conserver l\'emballage ou le reçu ?',
          content: 'Non ! Votre numéro de commande et le lien vers votre avis suffisent.',
        },
        item9: {
          header: 'Puis-je laisser l\'avis dans ma langue maternelle ?',
          content: 'Oui ! N\'importe quelle langue convient, tant qu\'il s\'agit d\'un avis authentique avec du texte et une image ou une vidéo.',
        },
        item10: {
          header: 'J\'ai commandé un autre produit, puis-je laisser un autre avis et obtenir un autre produit gratuit ?',
          content: 'Nous serions très heureux si vous nous laissiez un autre avis élogieux, mais malheureusement, nous ne pouvons envoyer les produits gratuits qu\'une seule fois par client.',
        }
      },
      form: {
        reviewLinkLabel: 'Lien vers votre évaluation Amazon *',
        reviewLinkPlaceholder: 'https://www.amazon...',
        reviewLinkRequiredMsg: 'Veuillez coller le lien vers votre avis !',
        reviewLinkValidUrlMsg: 'Veuillez entrer une URL valide !',
        orderNumberLabel: 'Numéro de commande Amazon *',
        orderNumberPlaceholder: 'ex: 123-4567890-1234567',
        orderNumberRequiredMsg: 'Veuillez entrer votre numéro de commande Amazon !',
        emailLabel: 'Votre adresse e-mail *',
        emailPlaceholder: 'votre.email@exemple.com',
        emailRequiredMsg: 'Veuillez entrer votre adresse e-mail !',
        emailValidMsg: 'Veuillez entrer une adresse e-mail valide !',
        shippingAddressLabel: 'Adresse de livraison (si différente de celle de votre commande)',
        streetPlaceholder: 'Rue et numéro',
        streetRequiredMsg: 'Veuillez entrer votre adresse postale !',
        cityPlaceholder: 'Ville',
        cityRequiredMsg: 'Veuillez entrer votre ville !',
        postalCodePlaceholder: 'Code postal',
        postalCodeRequiredMsg: 'Veuillez entrer votre code postal !',
        countryPlaceholder: 'Pays',
        countryRequiredMsg: 'Veuillez entrer votre pays !',        
        namePlaceholder: 'Nom complet',
        desiredProductLabel: "Produit(s) Colozoo que vous souhaitez (valeur totale jusqu'à 25 €) *",
        desiredProductLinkText: 'Parcourez notre boutique ici',
        desiredProductPlaceholder: "Entrez le(s) nom(s) ou ASIN du/des produit(s) que vous souhaitez",
        desiredProductRequiredMsg: 'Veuillez nous indiquer quel produit vous souhaitez !',
        consentCheckboxLabel: "Je comprends que cette offre est valable une fois par client et que mon avis inclut du texte et une photo/vidéo. Je consens également aux conditions décrites dans la politique de confidentialité. *",
        consentRequiredMsg: 'Vous devez accepter les conditions',
        marketingConsentCheckboxLabel: 'Envoyez-moi des e-mails sur les nouveaux produits Colozoo et autres promotions, nous promettons de ne pas vous spammer',
        submitButtonText: 'Soumettre la réclamation',
        submittingButtonText: 'Soumission en cours...',
        submissionSuccessTitle: 'Formulaire soumis !',
        submissionSuccessMessage: 'Merci ! Vous recevrez un message de confirmation juste après la soumission. Si vous n\'avez pas de nouvelles de notre part dans les 5 jours, n\'hésitez pas à contacter support@colozoo.de !',
        submissionErrorTitle: 'Erreur de soumission',
        submissionErrorMessage: 'Un problème est survenu lors de la soumission de votre réclamation. Veuillez réessayer ou contacter le support.',
        submissionFailedTitle: 'Échec de la soumission',
        submissionFailedMessage: 'Veuillez vérifier les champs du formulaire pour les erreurs.',
      }
    }
  },
  it: {
    landing: {
      docTitle: 'Colozoo - Richiedi il Tuo Regalo Gratuito',
      pageTitle: '🎨 Grazie per aver scelto Colozoo!',
      feedbackIntro: "Il tuo feedback significa molto per noi. Ci aiuta a crescere, migliorare e continuare a creare strumenti colorati e creativi che amerai.",
      freeProductOffer: "Come ringraziamento, ci piacerebbe regalarti un altro prodotto Colozoo (fino a 25€ di valore) gratuitamente!",
      howToClaimTitle: '🎁 Come richiedere il tuo regalo gratuito:',
      howToClaimStep1: 'Lascia una recensione su Amazon per il prodotto Colozoo che hai acquistato.',
      howToClaimStep1Detail: 'La tua recensione deve includere testo e almeno una foto o un video della tua arte o del prodotto in uso.',
      howToClaimStep2: 'Attendi 1-2 giorni che Amazon pubblichi la tua recensione (a volte possono essere lenti).',
      howToClaimStep3: 'Compila il modulo sottostante con:',
      howToClaimListItemReviewLink: 'Un link alla tua recensione',
      howToClaimListItemOrderNumber: 'Il tuo numero d\'ordine Amazon',
      howToClaimListItemEmail: 'Il tuo indirizzo email',
      howToClaimListItemShipping: 'Il tuo indirizzo di spedizione (se diverso da quello dell\'ordine)',
      howToClaimListItemProductChoice: 'Il/I prodotto/i Colozoo che desideri – fino a 25€ da',
      amazonStoreLinkText: 'il nostro negozio Amazon (clicca qui per navigare)',
      importantNotesTitle: '📝 Alcune note importanti:',
      importantNotesItem1: '📸 Adoriamo vedere le tue creazioni — più sono visive, meglio è!',
      importantNotesItem2: '🌍 Questa offerta è valida una volta per cliente.',
      importantNotesItem3: '🛒 Il tuo account Amazon deve aver effettuato acquisti per almeno 50€ negli ultimi 12 mesi per poter lasciare una recensione.',
      importantNotesItem4: '🌎 Questa promozione è aperta ai clienti in: Francia, Spagna, Germania, Danimarca, Svezia, Finlandia, Belgio, Portogallo, Italia, Irlanda, Lussemburgo, Paesi Bassi, Austria, Bulgaria, Croazia, Cipro, Repubblica Ceca, Estonia, Grecia, Ungheria, Lettonia, Lituania, Malta, Polonia, Romania, Slovacchia, Slovenia, Stati Uniti.',
      importantNotesItem5: '❌ Hai avuto un problema con il tuo ordine? Contattaci direttamente a support@colozoo.de invece di lasciare una recensione negativa — faremo tutto il possibile per aiutarti.',
      skipToFormButtonText: 'Pronto a richiedere il tuo regalo? Vai direttamente al modulo!',
      goToClaimFormButton: 'Vai al modulo di richiesta',
      faqTitle: '❓ Domande frequenti',
      examplesTitle: 'Ecco alcuni esempi di come appare una recensione eccellente:',
      viewExampleReviewButton: 'Visualizza esempio di recensione su Amazon',
      formTitle: '💌 Pronto/a? Compila il modulo sottostante per ricevere il tuo prodotto gratuito!',
      footerContact: 'Hai altre domande? Non esitare a contattarci su support@colozoo.de',
      footerColozooWebsite: 'Sito Web Colozoo',
      footerLegalNotice: 'Note Legali',
      footerPrivacyPolicy: 'Informativa sulla Privacy',
      links: {
        storeLink: "https://www.amazon.it/stores/Colozoo/page/6FBDACCD-D6A8-4017-971A-15D2488DE0D2",
        review1: "https://www.amazon.it/gp/customer-reviews/R8K1PV9YWQEOJ/",
        review2: "https://www.amazon.it/gp/customer-reviews/R1DT9BSJH8N85K/",
        review3: "https://www.amazon.it/gp/customer-reviews/R21OKMVV9PYXO9/"
      },
      faq: {
        item0: {
          header: 'Come lascio una recensione su Amazon?',
          contentLi1: 'Vai alla pagina del prodotto su Amazon per l\'articolo Colozoo che hai acquistato.',
          contentLi2: 'Scorri verso il basso fino alla sezione "Recensioni dei clienti".',
          contentLi3: 'Fai clic sul pulsante "Scrivi una recensione cliente".',
          contentLi4: 'Valuta il prodotto usando le stelle.',
          contentLi5: 'Scrivi il testo della tua recensione nell\'apposito spazio.',
          contentLi6Strong: 'Importante:',
          contentLi6Text: 'Fai clic su "Aggiungi una foto o un video" per caricare la tua immagine o il tuo video. Le recensioni devono includere un elemento visivo per qualificarsi per il regalo gratuito.',
          contentLi7: 'Fai clic su "Invia".',
          contentP1Text1: 'Ricorda, potrebbero essere necessari 1-2 giorni prima che Amazon pubblichi la tua recensione. Puoi trovare le tue recensioni inviate su',
          contentP1LinkText: 'la tua pagina Profilo Amazon',
          contentP1Text2: '.',
        },
        item1: {
          header: 'Posso scegliere più prodotti piccoli che sommati arrivino a 25€?',
          content: 'Puoi scegliere un prodotto fino a 25€. Tuttavia, per più prodotti, a causa degli alti costi di spedizione, possiamo spedire solo un valore totale fino a 15€.',
        },
        item2: {
          header: 'Quanto tempo prima di ricevere il mio omaggio?',
          content: 'Di solito lo spediamo entro una settimana dopo aver controllato la tua recensione. Ti invieremo una notifica non appena sarà in viaggio, e se non lo ricevi entro 10 giorni, ti preghiamo di scriverci a support@colozoo.de.',
        },
        item3: {
          header: 'Non voglio condividere la mia opera d\'arte nella recensione?',
          content: 'Nessun problema! Aggiungi semplicemente una foto del prodotto che hai ricevuto e scrivi qualche parola al riguardo.',
        },
        item4: {
          header: 'Non riesco a trovare il link alla mia recensione Amazon. Cosa devo fare?',
          contentP1Text1: 'A volte le recensioni impiegano fino a 72 ore per apparire. Puoi leggere tutte le recensioni che hai scritto visitando',
          contentP1LinkText: 'la tua pagina Profilo Amazon',
          contentP1Text2: 'e copiare l\'URL dal tuo browser.',
        },
        item5: {
          header: 'Cosa succede se il prodotto che voglio è esaurito?',
          content: 'Siamo spiacenti, puoi scegliere solo prodotti attualmente in stock e disponibili sul sito Amazon del tuo paese.',
        },
        item6: {
          header: 'Posso scegliere un prodotto superiore a 25€ e pagare la differenza?',
          content: 'Spiacenti, il regalo gratuito deve essere di 25€ o meno – non sono possibili integrazioni o pagamenti parziali.',
        },
        item7: {
          header: 'Come saprò che avete ricevuto il mio modulo?',
          content: 'Riceverai un messaggio di conferma subito dopo l\'invio (come implementato nel componente modulo). Se non ricevi nostre notizie entro 5 giorni, non esitare a contattare support@colozoo.de!',
        },
        item8: {
          header: 'Devo conservare l\'imballaggio o la ricevuta?',
          content: 'No! Bastano il tuo numero d\'ordine e il link alla recensione.',
        },
        item9: {
          header: 'Posso lasciare la recensione nella mia lingua madre?',
          content: 'Sì! Qualsiasi lingua va bene, purché sia una recensione autentica con testo e un\'immagine o un video.',
        },
        item10: {
          header: 'Ho ordinato un altro prodotto, posso lasciare un\'altra recensione e ottenere un altro prodotto gratuito?',
          content: 'Saremo molto felici se ci lascerai un\'altra recensione amorevole, ma sfortunatamente possiamo inviare i prodotti gratuiti solo una volta per cliente.',
        }
      },
      form: {
        reviewLinkLabel: 'Link alla tua recensione Amazon *',
        reviewLinkPlaceholder: 'https://www.amazon...',
        reviewLinkRequiredMsg: 'Incolla il link alla tua recensione!',
        reviewLinkValidUrlMsg: 'Inserisci un URL valido!',
        orderNumberLabel: 'Numero d\'ordine Amazon *',
        orderNumberPlaceholder: 'es. 123-4567890-1234567',
        orderNumberRequiredMsg: 'Inserisci il tuo numero d\'ordine Amazon!',
        emailLabel: 'Il tuo indirizzo email *',
        emailPlaceholder: 'tua.email@esempio.com',
        emailRequiredMsg: 'Inserisci il tuo indirizzo email!',
        emailValidMsg: 'Inserisci un indirizzo email valido!',
        shippingAddressLabel: 'Indirizzo di spedizione (se diverso da quello dell\'ordine)',
        streetPlaceholder: 'Via e numero civico',
        streetRequiredMsg: 'Inserisci il tuo indirizzo!',
        cityPlaceholder: 'Città',
        cityRequiredMsg: 'Inserisci la tua città!',
        postalCodePlaceholder: 'Codice postale',
        postalCodeRequiredMsg: 'Inserisci il tuo codice postale!',
        countryPlaceholder: 'Paese',
        countryRequiredMsg: 'Inserisci il tuo paese!',        
        namePlaceholder: 'Nome completo',
        desiredProductLabel: "Prodotto/i Colozoo che desideri (valore totale fino a 25€) *",
        desiredProductLinkText: 'Sfoglia il nostro negozio qui',
        desiredProductPlaceholder: "Inserisci il/i nome/i o ASIN del/i prodotto/i che desideri",
        desiredProductRequiredMsg: 'Dicci quale prodotto vorresti!',
        consentCheckboxLabel: "Comprendo che questa offerta è valida una volta per cliente e la mia recensione include testo e una foto/video. Acconsento inoltre ai termini descritti nell'informativa sulla privacy. *",
        consentRequiredMsg: 'Devi accettare i termini',
        marketingConsentCheckboxLabel: 'Inviami email su nuovi prodotti Colozoo e altre promozioni, promettiamo di non spammarti',
        submitButtonText: 'Invia Richiesta',
        submittingButtonText: 'Invio in corso...',
        submissionSuccessTitle: 'Modulo Inviato!',
        submissionSuccessMessage: 'Grazie! Riceverai un messaggio di conferma subito dopo l\'invio. Se non ricevi nostre notizie entro 5 giorni, non esitare a contattare support@colozoo.de!',
        submissionErrorTitle: 'Errore di Invio',
        submissionErrorMessage: 'Si è verificato un problema durante l\'invio della tua richiesta. Riprova o contatta l\'assistenza.',
        submissionFailedTitle: 'Invio Fallito',
        submissionFailedMessage: 'Controlla i campi del modulo per errori.',
      }
    }
  },
  es: {
    landing: {
      docTitle: 'Colozoo - Reclama Tu Regalo Gratis',
      pageTitle: '🎨 ¡Gracias por elegir Colozoo!',
      feedbackIntro: "Tus comentarios significan mucho para nosotros. Nos ayudan a crecer, mejorar y seguir creando herramientas coloridas y creativas que te encantarán.",
      freeProductOffer: "Como agradecimiento, ¡nos encantaría regalarte otro producto Colozoo (de hasta 25€ de valor) gratis!",
      howToClaimTitle: '🎁 Cómo reclamar tu regalo gratis:',
      howToClaimStep1: 'Deja una reseña en Amazon del producto Colozoo que compraste.',
      howToClaimStep1Detail: 'Tu reseña debe incluir texto y al menos una foto o video de tu arte o del producto en uso.',
      howToClaimStep2: 'Espera 1 o 2 días a que Amazon publique tu reseña (a veces pueden tardar).',
      howToClaimStep3: 'Rellena el siguiente formulario con:',
      howToClaimListItemReviewLink: 'Un enlace a tu reseña',
      howToClaimListItemOrderNumber: 'Tu número de pedido de Amazon',
      howToClaimListItemEmail: 'Tu dirección de correo electrónico',
      howToClaimListItemShipping: 'Tu dirección de envío (si es diferente a la de tu pedido)',
      howToClaimListItemProductChoice: 'El/los producto(s) Colozoo que te gustaría(n) – hasta 25€ de',
      amazonStoreLinkText: 'nuestra tienda de Amazon (haz clic aquí para navegar)',
      importantNotesTitle: '📝 Algunas notas importantes:',
      importantNotesItem1: '📸 ¡Nos encanta ver tus creaciones! Cuanto más visual, ¡mejor!',
      importantNotesItem2: '🌍 Esta oferta es válida una vez por cliente.',
      importantNotesItem3: '🛒 Tu cuenta de Amazon debe tener al menos 50€ en compras en los últimos 12 meses para poder dejar una reseña.',
      importantNotesItem4: '🌎 Esta promoción está abierta a clientes en: Francia, España, Alemania, Dinamarca, Suecia, Finlandia, Bélgica, Portugal, Italia, Irlanda, Luxemburgo, Países Bajos, Austria, Bulgaria, Croacia, Chipre, República Checa, Estonia, Grecia, Hungría, Letonia, Lituania, Malta, Polonia, Rumania, Eslovaquia, Eslovenia, EE. UU.',
      importantNotesItem5: '❌ ¿Tuviste algún problema con tu pedido? Contáctanos directamente en support@colozoo.de en lugar de dejar una reseña negativa; haremos todo lo posible para ayudarte.',
      skipToFormButtonText: '¿Listo para reclamar tu regalo? ¡Salta directamente al formulario!',
      goToClaimFormButton: 'Ir al formulario de reclamación',
      faqTitle: '❓ Preguntas frecuentes',
      examplesTitle: 'Aquí tienes algunos ejemplos de cómo se ve una excelente reseña:',
      viewExampleReviewButton: 'Ver ejemplo de reseña en Amazon',
      formTitle: '💌 ¿Listo/a? ¡Rellena el formulario de abajo para conseguir tu producto gratis!',
      footerContact: '¿Tienes alguna otra pregunta? No dudes en contactarnos en support@colozoo.de',
      footerColozooWebsite: 'Sitio Web de Colozoo',
      footerLegalNotice: 'Aviso Legal',
      footerPrivacyPolicy: 'Política de Privacy',
      links: {
        storeLink: "https://www.amazon.es/stores/Colozoo/page/938FD6BE-3585-4F1E-A08F-47E8AAEC8615",
        review1: "https://www.amazon.es/gp/customer-reviews/R8K1PV9YWQEOJ/",
        review2: "https://www.amazon.es/gp/customer-reviews/R1DT9BSJH8N85K/",
        review3: "https://www.amazon.es/gp/customer-reviews/R21OKMVV9PYXO9/"
      },
      faq: {
        item0: {
          header: '¿Cómo dejo una reseña en Amazon?',
          contentLi1: 'Ve a la página del producto en Amazon del artículo Colozoo que compraste.',
          contentLi2: 'Desplázate hacia abajo hasta la sección "Opiniones de clientes".',
          contentLi3: 'Haz clic en el botón "Escribir una opinión de cliente".',
          contentLi4: 'Valora el producto usando las estrellas.',
          contentLi5: 'Escribe el texto de tu reseña en el cuadro provisto.',
          contentLi6Strong: 'Importante:',
          contentLi6Text: 'Haz clic en "Añadir foto o vídeo" para subir tu imagen o vídeo. Las reseñas deben incluir un elemento visual para calificar para el regalo gratuito.',
          contentLi7: 'Haz clic en "Enviar".',
          contentP1Text1: 'Recuerda, Amazon puede tardar 1 o 2 días en publicar tu reseña. Puedes encontrar tus reseñas enviadas en',
          contentP1LinkText: 'tu página de Perfil de Amazon',
          contentP1Text2: '.',
        },
        item1: {
          header: '¿Puedo elegir varios productos pequeños que sumen 25€?',
          content: 'Puedes elegir un producto hasta 25€. Sin embargo, para múltiples productos, debido a los altos costos de envío, solo podemos enviar un valor total de hasta 15€.',
        },
        item2: {
          header: '¿Cuánto tardaré en recibir mi regalo?',
          content: 'Normalmente lo enviamos en una semana después de verificar tu reseña. Te enviaremos una notificación una vez que esté en camino, y si no lo recibes en 10 días, por favor escríbenos a support@colozoo.de.',
        },
        item3: {
          header: '¿No quiero compartir mi obra de arte en la reseña?',
          content: '¡No hay problema! Simplemente añade una foto del producto que recibiste y escribe unas palabras sobre él.',
        },
        item4: {
          header: 'No encuentro el enlace a mi reseña de Amazon. ¿Qué debo hacer?',
          contentP1Text1: 'A veces, las reseñas tardan hasta 72 horas en aparecer. Puedes leer todas las reseñas que has escrito visitando',
          contentP1LinkText: 'tu página de Perfil de Amazon',
          contentP1Text2: 'y copiar la URL de tu navegador.',
        },
        item5: {
          header: '¿Qué pasa si el producto que quiero está agotado?',
          content: 'Lo sentimos, solo puedes elegir productos que estén actualmente en stock y disponibles en el sitio web de Amazon de tu país.',
        },
        item6: {
          header: '¿Puedo elegir un producto de más de 25€ y pagar la diferencia?',
          content: 'Lo sentimos, el regalo gratuito debe ser de 25€ o menos; no son posibles recargas ni pagos parciales.',
        },
        item7: {
          header: '¿Cómo sabré que han recibido mi formulario?',
          content: 'Recibirás un mensaje de confirmation justo después de enviarlo (tal como está implementado en el componente del formulario). Si no tienes noticias nuestras en 5 días, ¡no dudes en contactar con support@colozoo.de!',
        },
        item8: {
          header: '¿Necesito guardar el embalaje o el recibo?',
          content: '¡No! Solo tu número de pedido y el enlace de la reseña son suficientes.',
        },
        item9: {
          header: '¿Puedo dejar la reseña en mi idioma nativo?',
          content: '¡Sí! Cualquier idioma está bien, siempre que sea una reseña genuina con texto y una imagen o vídeo.',
        },
        item10: {
          header: 'He pedido otro producto, ¿puedo dejar otra reseña y obtener otro producto gratis?',
          content: 'Estaremos muy contentos si nos dejas otra reseña cariñosa, pero lamentablemente solo podemos enviar los productos gratuitos una vez por cliente.',
        }
      },
      form: {
        reviewLinkLabel: 'Enlace a tu reseña de Amazon *',
        reviewLinkPlaceholder: 'https://www.amazon...',
        reviewLinkRequiredMsg: '¡Por favor, pega el enlace a tu reseña!',
        reviewLinkValidUrlMsg: '¡Por favor, introduce una URL válida!',
        orderNumberLabel: 'Número de pedido de Amazon *',
        orderNumberPlaceholder: 'ej: 123-4567890-1234567',
        orderNumberRequiredMsg: '¡Por favor, introduce tu número de pedido de Amazon!',
        emailLabel: 'Tu dirección de correo electrónico *',
        emailPlaceholder: 'tu.email@ejemplo.com',
        emailRequiredMsg: '¡Por favor, introduce tu dirección de correo electrónico!',
        emailValidMsg: '¡Por favor, introduce una dirección de correo electrónico válida!',
        shippingAddressLabel: 'Dirección de envío (si es diferente a la de tu pedido)',
        streetPlaceholder: 'Calle y número',
        streetRequiredMsg: '¡Por favor, introduce tu dirección!',
        cityPlaceholder: 'Ciudad',
        cityRequiredMsg: '¡Por favor, introduce tu ciudad!',
        postalCodePlaceholder: 'Código postal',
        postalCodeRequiredMsg: '¡Por favor, introduce tu código postal!',
        countryPlaceholder: 'País',
        countryRequiredMsg: '¡Por favor, introduce tu país!',        
        namePlaceholder: 'Nombre completo',
        desiredProductLabel: "Producto(s) Colozoo que te gustaría(n) (valor total hasta 25€) *",
        desiredProductLinkText: 'Explora nuestra tienda aquí',
        desiredProductPlaceholder: "Introduce el/los nombre/s o ASIN del/de los producto/s que te gustaría/n",
        desiredProductRequiredMsg: '¡Por favor, dinos qué producto te gustaría!',
        consentCheckboxLabel: "Entiendo que esta oferta es válida una vez por cliente y mi reseña incluye texto y una foto/vídeo. También acepto los términos descritos en la política de privacidad. *",
        consentRequiredMsg: 'Debes aceptar los términos',
        marketingConsentCheckboxLabel: 'Envíame correos electrónicos sobre nuevos productos Colozoo y otras promociones, prometemos no enviarte spam',
        submitButtonText: 'Enviar Reclamación',
        submittingButtonText: 'Enviando...',
        submissionSuccessTitle: '¡Formulario Enviado!',
        submissionSuccessMessage: '¡Gracias! Recibirás un mensaje de confirmación justo después de enviarlo. Si no tienes noticias nuestras en 5 días, ¡no dudes en contactar con support@colozoo.de!',
        submissionErrorTitle: 'Error de Envío',
        submissionErrorMessage: 'Hubo un problema al enviar tu reclamación. Por favor, inténtalo de nuevo o contacta con el soporte.',
        submissionFailedTitle: 'Envío Fallido',
        submissionFailedMessage: 'Por favor, comprueba los campos del formulario por errores.',
      }
    }
  }
}